"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InstanceCreationResultModule = /** @class */ (function () {
    function InstanceCreationResultModule() {
    }
    return InstanceCreationResultModule;
}());
exports.InstanceCreationResultModule = InstanceCreationResultModule;
